import { Routes } from '@angular/router';
import { ZurichLayoutComponent } from './guias/zurich/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'singuia',
    pathMatch: 'full',
  },
  {
    path: 'singuia',
    loadComponent: () => import('./guias/singuia/singuia.component').then((m) => m.SinGuiaComponent),
    data: {
      title: 'Zurich',
    },
  },
  {
    path: 'Zurich',
    component: ZurichLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./guias/zurich/zurich.routes').then((m) => m.routes),
      }
    ]

  },
  { path: '**', redirectTo: '' },
];
